exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-js-switch.changed-font[data-v-7c44db55] {\n  font-size: .8em;\n}\n", ""]);

// exports
